/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/SubDetailGridEditor.ts" />

namespace TabAurous.Retail {

    import fld = POSSalesReceiptDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class POSSalesReceiptDetailsEditor extends _Ext.SubDetailGridEditor<POSSalesReceiptDetailsRow> {

        protected getColumnsKey() { return "Retail.POSSalesReceiptDetails"; }
        protected getLocalTextPrefix() { return POSSalesReceiptDetailsRow.localTextPrefix; }
        protected form: POSSalesReceiptForm;
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.EnableQuickSearch = false;
            return opt;
        }
        private pendingChanges: Q.Dictionary<any> = {};

        cont: JQuery;


        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {

                    (this.parentDialog as POSSalesReceiptDialog).setAmount();
                }
            });
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));

        }
        getColumns() {
            var columns = super.getColumns();

            //Q.first(columns, x => x.field === fld.Amount).format = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Count).format = ctx => ColumnFormatter.integerInputFormatter(ctx, this);


            return columns;
        }
        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Amount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            } else if (field === fld.Count) {
                value = Q.parseInteger(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

           
            if (field === fld.Count && value > 0) {
                var code = item.Code;                
                item[field] = value;
                item.Amount = code * value;

            }
            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as POSSalesReceiptDialog).setAmount();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }
        setData() {
            this.view.setItems([]);
            OMS.DenominationService.List(
                {
                    Sort: ["Code"]
                },
                response => {
                    var denominations = response.Entities;
                    if (denominations != null && denominations.length > 0) {
                        for (var i = 0; i < denominations.length; i++) {
                            var denomination = denominations[i];
                            var newdenomination: POSSalesReceiptDetailsRow = {
                                DenominationId: denomination.DenominationId,
                                Code: denomination.Code
                            };
                            newdenomination[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(newdenomination);
                        }
                    }
                }, { async: false });
        }
        setNullvalues(details: any[]) {
            this.view.setItems([]);

            for (var i = 0; i < details.length; i++) {
                var denomination = details[i]; 
                denomination[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(denomination);
            }
        }
    }
}